// Branding Eats aligné sur VTC (or + noir), miroir de
// mobile-app/src/common/eatBrand.js — mêmes valeurs.
export const EAT_GREEN = '#d4af37';
export const EAT_DARK_GREEN = '#111318';
export const EAT_BORDER_GREEN = '#b8941f';
export const EAT_LIGHT_GREEN = '#f4e4a6';
